var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',_vm._b({ref:"input",staticClass:"input-sigarus-checkbox",model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'el-checkbox',{..._vm.$attrs, ..._vm.$props},false),[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }